import UgcGoBackButton from "./GoBackButton";

export default UgcGoBackButton;
